import io from "socket.io-client";

import Auth from "../../auth";

const socket = io(process.env.REACT_APP_APP_WS_URL, {
  query: { user: Auth.isAuth() ? Auth.isAuth().id : 0 }
});

export default socket;
